import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgV2AlertCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	"xmlns:svgjs": "http://svgjs.com/svgjs",
	viewBox: "0 0 16 16",
	width: 16,
	height: 16,
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "matrix(0.6666666666666666,0,0,0.6666666666666666,0,0)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12,16.5a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,16.5h0",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 13.5L12 5.25",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeMiterlimit: 10,
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z",
				fill: "none",
				stroke: "currentColor",
				strokeMiterlimit: 10,
				strokeWidth: 2
			})
		]
	})
});
export default SvgV2AlertCircle;
